// CRM 2.0: booking amount paid, Relationship Manager not final yet (M2-F9, M2.23, DC-82 / DC-83 / DC-84).
// Amber attention box + "Application for Booking · not started" steps. No ring, day count or due
// date, and no Agreement KYC button (Allotment.jsx hides it). Gone once the CRM is final.
import React from "react";
import { NextBox, Steps, UserIconSvg } from "./Crm2Parts";
import { WAITRM } from "./useCrm2Booking";
import css from "./Crm2Booking.module.css";

export default function WaitingForRm({ info }) {
	const sm = info?.salesManager;
	return (
		<>
			<NextBox
				who="holdrm"
				title={WAITRM}
				side={
					<div className={css.hglass}>
						<UserIconSvg />
						<span>
							Assigning your
							<br />
							Relationship Manager
						</span>
					</div>
				}
			>
				<ul className={css.hl}>
					<li>
						<b>Usually within 1 working day.</b> We tell you by email and WhatsApp with their name and number.
					</li>
					<li>
						Your <b>Application for Booking starts then</b>: first you confirm your Application for Booking by OTP, then the Agreement KYC.
					</li>
				</ul>
				{sm?.name && (
					<div className={css.hlq}>
						Questions now: Sales Manager <b>{sm.name}</b>
						{sm.phone ? ` · ${sm.phone}` : ""}
					</div>
				)}
			</NextBox>
			<Steps
				title="Application for Booking"
				sub="not started · starts when your Relationship Manager is assigned"
				rows={[
					["ok", "Booking amount", "Paid · unit status Shortlisted → Applied"],
					["wait", "Relationship Manager", WAITRM],
					["todo", "Application for Booking", "Sent by email and WhatsApp when the stage starts · you confirm it by OTP"],
					["todo", "Agreement KYC", "Opens after you confirm your Application for Booking"],
					["todo", "Review draft", "After you submit your KYC"],
				]}
			/>
		</>
	);
}
